import { Box, InputAdornment, Typography } from '@material-ui/core'
import TextField from '@mui/material/TextField'
import { useMemo } from 'react'
import { IconButton } from '@mui/material'
import { SearchOutlined, ClearOutlined } from '@mui/icons-material'
import {
  getAssociatedTickets,
  linkInternalTicketsToZendeskTicket,
} from '../api'
import { TicketCard } from '../components/TicketCard'
import { FixedMainButton } from '../components/FixedMainButton'
import config from '../../../config'

export const ZendeskPluginLink = ({
  searchValue,
  setSearchValue,
  setShowHomePage,
  unlinkedInternalTickets,
  currentZendeskTicket,
  setUnlinkedInternalTickets,
  setLinkedInternalTickets,
}) => {
  if (!unlinkedInternalTickets) {
    return <div>Loading...</div>
  }

  const checkedTickets = useMemo(() => {
    return unlinkedInternalTickets.reduce(
      (acc, ticket) => (ticket.isChecked ? acc + 1 : acc),
      0
    )
  }, [unlinkedInternalTickets])

  const handleCheckboxChange = (ticketId) => {
    setUnlinkedInternalTickets((prevTickets) =>
      prevTickets.map((ticket) =>
        ticket.id === ticketId
          ? { ...ticket, isChecked: !ticket.isChecked }
          : ticket
      )
    )
  }

  const linkTicket = () => {
    if (currentZendeskTicket && unlinkedInternalTickets?.length > 0) {
      const selectedTickets = unlinkedInternalTickets.reduce((acc, ticket) => {
        const isDraftTicket = !ticket.stateName
        if (ticket.isChecked) {
          acc.push({ id: ticket.id, isDraftTicket })
        }
        return acc
      }, [])

      linkInternalTicketsToZendeskTicket(currentZendeskTicket.zendeskId, {
        tickets: selectedTickets,
        zendeskTicket: currentZendeskTicket,
      })
        .then(() => {
          return getAssociatedTickets(currentZendeskTicket.zendeskId)
        })
        .then((data) => {
          setLinkedInternalTickets(data)
        })
    }
    setShowHomePage(true)
  }

  return (
    <Box>
      <TextField
        style={{ width: '100%', marginBottom: '10px' }}
        size={'small'}
        placeholder="Référence, ID, Titre"
        inputProps={{ 'aria-label': 'search' }}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {searchValue && (
                <>
                  <IconButton onClick={() => setSearchValue('')}>
                    <ClearOutlined />
                  </IconButton>
                </>
              )}
              <IconButton disabled={true}>
                <SearchOutlined />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {unlinkedInternalTickets?.length > 0 ? (
        unlinkedInternalTickets.map((ticket, index) => (
          <TicketCard
            key={ticket.id}
            ticket={ticket}
            isChecked={ticket.isChecked}
            handleCheckboxChange={handleCheckboxChange}
            isLastCard={index === unlinkedInternalTickets.length - 1}
          />
        ))
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100%',
            marginY: '20px',
          }}
        >
          <Typography variant="h6">Aucun ticket trouvé</Typography>
          <img
            src={`${config.PUBLIC_URL}/img/mandy_no-result.png`}
            style={{
              width: '40%',
            }}
          />
        </Box>
      )}

      {!!checkedTickets && (
        <FixedMainButton
          title={`Lier ${checkedTickets} ticket(s)`}
          handleOnClick={linkTicket}
        />
      )}
    </Box>
  )
}
